/** Static Web Apps built-in authentication helpers (the /.auth endpoints). */

export interface ClientPrincipal {
	identityProvider: string;
	userId: string;
	userDetails: string;
	userRoles: string[];
	claims?: { typ: string; val: string }[];
}

/** The signed-in user, or null when anonymous (or when running outside the SWA runtime). */
export async function getPrincipal(): Promise<ClientPrincipal | null> {
	try {
		const res = await fetch("/.auth/me", { credentials: "same-origin", headers: { accept: "application/json" } });
		if (!res.ok) return null;
		const body = (await res.json()) as { clientPrincipal?: ClientPrincipal | null };
		return body.clientPrincipal ?? null;
	} catch {
		return null;
	}
}

export function loginUrl(returnTo: string = location.pathname + location.search): string {
	return `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(returnTo)}`;
}

export function logoutUrl(): string {
	return `/.auth/logout?post_logout_redirect_uri=${encodeURIComponent("/")}`;
}

export function displayName(p: ClientPrincipal): string {
	return p.claims?.find((c) => c.typ === "name")?.val ?? p.userDetails;
}
